import { getRecordList } from 'services';

export default {
  namespace: 'record',
  state: {
    list: [],
    pages: 0
  },
  effects: {
    *init({ payload }, { call, put }) {
      const response = yield call(getRecordList, payload);
      if (response.data.state === '11') {
        yield put({
          type: 'setData',
          payload: {
            list: response.data.page.result,
            pages: response.data.page.pages
          }
        });
      }
    },
    *queryRecordList({ payload }, { call, put, select }) {
      const data = yield select(({ record }) => record.list);
      const response = yield call(getRecordList, payload);
      if (response.data.state === '11') {
        yield put({
          type: 'setData',
          payload: {
            list: data.concat(response.data.page.result),
            pages: response.data.page.pages
          }
        });
      }
    }
  },
  reducers: {
    setData(state, { payload }) {
      return {
        ...state,
        ...payload
      };
    },
  }
};
